import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const BUSINESS = {
    name: "NextGen Cleaning Services",
    owner: "Ben Hladun",
    phone: "916 599 9448",
    phoneHref: "tel:+19165999448",
    area: "Roseville & the Greater Sacramento Area",
};

export const SERVICES = [
    {
        id: "single_bin",
        title: "Single Bin Cleaning",
        price: 20,
        unit: "per service",
        blurb: "One curbside bin, blasted spotless with 200°F pressurized water. Deodorized, sanitized, streak-free.",
    },
    {
        id: "double_bin",
        title: "Two Bin Cleaning",
        price: 35,
        unit: "per service",
        blurb: "Trash + recycling, done together. The best value for the whole household.",
        featured: true,
    },
    {
        id: "dog_poop",
        title: "Dog Poop Cleaning",
        price: 10,
        unit: "add-on",
        blurb: "Yard scooped and hauled away so your lawn stays fresh and family-safe.",
    },
    {
        id: "car_wash",
        title: "Car Exterior Wash",
        price: 25,
        unit: "add-on",
        blurb: "A gleaming hand-washed exterior while we're already at your driveway.",
    },
];
